module.exports = __webpack_public_path__ + "img/order.22ac424d.webp";